import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import Home from '@/pages/home'
import PracticeCompany from '@/pages/practice/company'
import PracticeCompanyCode from '@/pages/practice/company-code'
import PracticeCode from '@/pages/practice/code'
import DetailControl from '@/pages/detail'
import DemoControl from '@/pages/demo'
import SystemControl from '@/pages/system'
import ProductExam from '@/pages/product/exam.vue'
import ProductInterview from '@/pages/product/interview'
import SceneControl from '@/pages/scene'
import TariffControl from '@/pages/tariff'
import TariffInterviewControl from '@/pages/tariff/interview'
import CustomerControl from '@/pages/customer'
import AboutControl from '@/pages/about'
import LoginControl from '@/pages/account/login'
import RegControl from '@/pages/account/register'
import CalendarControl from '@/pages/calendar'
import CompInfoControl from '@/pages/account/compInfo'
import StateControl from '@/pages/state'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/home',
      component: Layout,
      children: [
        {
          path: '/home',
          component: Home
        },

        {
          path: '/scene',
          component: SceneControl
        },
        {
          path: '/tariff/exam',
          component: TariffControl
        },
        {
          path: '/tariff/interview',
          component: TariffInterviewControl
        },
        {
          path: '/customer',
          component: CustomerControl
        },
        {
          path: '/calendar',
          component: CalendarControl
        },
        {
          path: '/practice/company',
          component: PracticeCompany
        },
        {
          path: '/practice/company-code',
          component: PracticeCompanyCode
        },
        {
          path: '/practice/code',
          component: PracticeCode
        },
        {
          path: '/link/about',
          component: AboutControl
        },
        {
          path: '/link/concat',
          component: DetailControl
        },
        {
          path: '/link/state',
          component: StateControl
        },
        {
          path: '/link/publicity',
          component: DetailControl
        },
        {
          path: '/demo',
          component: DemoControl
        }
      ]
    },
    {
      path: '/system',
      component: SystemControl
    },
    {
      path: '/login',
      component: LoginControl
    },
    {
      path: '/register',
      component: RegControl
    },
    {
      path: '/register/compInfo',
      component: CompInfoControl
    },
    {
      path: '/product',
      redirect: '/product/exam',
      component: Layout,
      children: [
        {
          path: '/product/exam',
          component: ProductExam
        },
        {
          path: '/product/interview',
          component: ProductInterview
        }
      ]
    },
    {
      path: '*',
      redirect: '/practice/company'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js